// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cloudUpload16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cloud-upload': IconCloudUpload;
    }
}

/**
 * The icon component for the 'cloudUpload' icon
 */
export class IconCloudUpload extends IconSvg {
    public constructor() {
        super(cloudUpload16X16);
    }
}

registerIconSvg('icon-cloud-upload', IconCloudUpload);
export const iconCloudUploadTag = 'nimble-icon-cloud-upload';
